import { useForm } from 'react-hook-form';
import BlockStepsButtons from '../BlockStepsButtons';
import LoanApplicationFactory from '../../../domain/newLoanApplication/LoanApplicationFactory';
import Collection from '../../../domain/valueObject/Collection';
import PartInputField from '../../parts/PartInputField';
import { NewLoanSteps } from '../../../utils/enums';
import { NewLoanApplicationStepsProps } from '../../../pages/NewLoanApplication';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useEffect } from 'react';

interface TransactionPurchasePriceProps extends NewLoanApplicationStepsProps {}

const TransactionPurchasePrice = ({
    nextStep,
    prevStep,
    newLoanEntity
}: TransactionPurchasePriceProps) => {
    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        formState: { errors }
    } = useForm({
        mode: 'onChange',
        shouldFocusError: false,
        resolver: yupResolver(
            yup.object().shape({
                purchasePrice: yup
                    .string()
                    .required('Please complete this required field.')
                    .matches(
                        /(?=.*?\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/,
                        'You must specify a number.'
                    )
            })
        )
    });

    const onSubmit = (data: any) => {
        LoanApplicationFactory.makeFromForm(
            newLoanEntity,
            new Collection(data)
        );

        nextStep(NewLoanSteps.LOAN_TYPE);
    };

    const handlePrevStep = () => {
        LoanApplicationFactory.makeFromForm(
            newLoanEntity,
            new Collection(getValues())
        );
        prevStep(NewLoanSteps.TRANSACTION_TYPE);
    };

    useEffect(() => {
        newLoanEntity.hasPurchasePrice() &&
            setValue('purchasePrice', newLoanEntity.purchasePrice.value);
    }, []);

    return (
        <div className="login">
            <div className="container">
                <h1 className="login__title">
                    What is your purchase price for this property?
                </h1>
                <p className="login__subtitle login__subtitle--middle">
                    Transaction Details
                </p>
                <div className="login__box">
                    <PartInputField
                        label="Purchase Price"
                        name="purchasePrice"
                        control={control}
                        errors={errors}
                        isRequired
                        isDollarAmount={true}
                    />
                    <BlockStepsButtons
                        prevStep={handlePrevStep}
                        nextStep={handleSubmit(onSubmit)}
                    />
                </div>
            </div>
        </div>
    );
};

export default TransactionPurchasePrice;
